import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";

// shown when the editor is closed with unsaved changes. Save persists then closes;
// Discard closes without saving. Dismissing (backdrop/escape) leaves the editor open.
export function ConfirmCloseDialog(props: {
    onSave(): void;
    onDiscard(): void;
    onDismiss(): void;
}) {
    return (
        <Dialog2 open onClose={props.onDismiss} onEnterPress={props.onSave}>
            <DialogTitle>Pending changes</DialogTitle>
            <DialogContent>
                You have unsaved changes. Do you want to save them?
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onDiscard}>Discard</Button>
                <Button variant="contained" onClick={props.onSave}>Save</Button>
            </DialogActions>
        </Dialog2>
    );
}
